import React from 'react';
import Tile from '../../../app/common/components/Tile';
import OverlayDialog from '../../../app/common/components/OverlayDialog';
import Spinner from '../../../app/common/components/Spinner';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import ICONS from '../../../app/common/constants/icons';
import Icon from '../../../app/common/components/Icon';
import DeleteConfirmation from '../DeleteConfirmation';
import {
    AgreementLink,
    Bottom,
    DeleteLink,
    DeleteLinkWrapper,
    ImgLogo,
    IntroText,
    Loading,
    mainTileStyles,
    ServiceInfo,
    ServiceLogo,
    Wrapper,
} from '../sharedStyles';
import OptionalCheckboxBlock from './OptionalCheckboxBlock';
import PrivacyCenter from '../PrivacyCenter';

export default class RakutenService extends PrivacyCenter {
    extractMandatoryConsents(mandatoryConsents) {
        return mandatoryConsents.map((consent, i) => {
            const translationKey = 'rakservice.check.' + consent.translationKey;
            return (
                <AgreementLink
                    href={consent.url}
                    key={i}
                    onClick={(e) =>
                        this.onExternalLinkClick(e, {
                            page: 'Privacy',
                            destination: this.getAnalyticsDestination(consent.translationKey),
                        })
                    }
                >
                    {TranslationHelpers.getFormattedMessage(translationKey)}
                </AgreementLink>
            );
        });
    }

    extractOptionalConsents(optionalConsents, serviceUuid) {
        return optionalConsents.map((consent, i) => {
            return (
                <OptionalCheckboxBlock
                    serviceUuid={serviceUuid}
                    consent={consent}
                    key={i}
                    updateOptionalConsentStatus={this.updateOptionalConsentStatus}
                    locale={this.props.locale}
                />
            );
        });
    }

    render() {
        const {
            services,
            servicesConfig,
            gettingServicesAndConsentsStatus,
            errorDeletingAccount,
            loadingServicesConfig,
            loadingServicesConfigError,
            clientConfig,
        } = this.props;

        const showOptionalConsents =
            clientConfig.presentationConfig.showSections['services.v2.showOptionalConsents'] ??
            true;

        const someServiceUpdating = services.some((service) => service.updating);

        return (
            <Wrapper>
                <OverlayDialog
                    title={TranslationHelpers.getMessageDescriptor(
                        'rakservice.delete_confirmation.title',
                    )}
                    isOpen={this.state.isOverlayOpen}
                    onClose={this.onConfirmationClose}
                >
                    <DeleteConfirmation
                        onAccept={this.onAcceptDelete}
                        onClose={this.onConfirmationClose}
                        apiError={errorDeletingAccount}
                        deleting={this.props.deleteConfirmationOpen}
                    />
                </OverlayDialog>
                {(gettingServicesAndConsentsStatus ||
                    loadingServicesConfig ||
                    someServiceUpdating ||
                    loadingServicesConfigError) && (
                    <Loading>
                        <Spinner size={50} />
                    </Loading>
                )}

                {services &&
                    servicesConfig &&
                    !loadingServicesConfigError &&
                    services.map((service, index) => {
                        const { logo, name, description } = this.getServiceDetailsByConfig(service);

                        if (!name) {
                            return null;
                        }
                        let mandatoryConsents;
                        let optionalConsents;
                        if (service.mandatoryConsents) {
                            mandatoryConsents = this.extractMandatoryConsents(
                                service.mandatoryConsents,
                            );
                        }
                        if (
                            showOptionalConsents &&
                            service.optionalConsents &&
                            service.optionalConsents.consents
                        ) {
                            optionalConsents = this.extractOptionalConsents(
                                service.optionalConsents.consents,
                                service.serviceUuid,
                            );
                        }
                        return (
                            <Tile localStyles={mainTileStyles} key={index}>
                                <ServiceInfo>
                                    <ServiceLogo>
                                        <ImgLogo src={logo} alt={name} data-qa-id={name} />
                                    </ServiceLogo>
                                    <IntroText className="tst-rsintro">
                                        {TranslationHelpers.getFormattedMessage(description, {
                                            serviceName: name,
                                        })}
                                    </IntroText>
                                    {mandatoryConsents}
                                    {optionalConsents}
                                </ServiceInfo>
                            </Tile>
                        );
                    })}

                <Bottom>
                    <DeleteLinkWrapper>
                        <DeleteLink href="#" onClick={this.onDeleteClick}>
                            <Icon icon={ICONS.TRUSH} />
                            <span>
                                {TranslationHelpers.getFormattedMessage('button.delete_account')}
                            </span>
                        </DeleteLink>
                    </DeleteLinkWrapper>
                </Bottom>
            </Wrapper>
        );
    }
}
